import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated} from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import SalesNoteLinkNavigation from "../../../KDPSalesNoteLinkNavigationContainer.vue";
import SalesNoteHeaderNavigation from "../../../KDPSalesNoteHeaderNavigationContainer.vue";
import ResponseData from "@/types/ResponseData";
import IssueSalesNoteDataService from "@/services/KDPIssueSalesNoteDataService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const router = useRouter();
const isLoadingcheck = ref("");

const paramSalesNote = reactive([]);

onMounted(function () {
  /** パラメータ取得 */
  paramSalesNote.splice(0);
  paramSalesNote.push(...store.getters.paramKDPSalesNoteList);
});

onUpdated(function () {
  try {
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var tableHeight = document.getElementById("tblbodydiv")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
        document.getElementById("tblbodydiv").style.borderBottom = "#ccc solid 0.5px";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    console.log(e);
  }
});

// 確認メッセージ表示のため
const showModal = () => {
  if (confirm(i18n.t("cnf013"))){
    goOK();
  }  
};

/** OKボタンイベント */
const goOK = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  // パラメータ
  const salesNoteInfo = {
    paramSalesNote : paramSalesNote,
    userId : store.getters.cognitoUserName
  }  
  isLoadingcheck.value = "true";
  isLoading.value= true;
  IssueSalesNoteDataService.updateKDPSalesNoteApprovalStatusList(salesNoteInfo)
  .then((response: ResponseData) => {
      if (response.data.message == 'success') {
        isLoading.value= false;
        /** 一覧画面へ戻る */
        store.dispatch("setParamKDPSalesNoteList", null);
        /** 検索モードで表示するため*/
        var searchInfo = store.getters.kdpSalesNoteSearchData || null;
        searchInfo.mode = 'Search';
        store.dispatch("setKDPSalesNoteSearchData", searchInfo);
        router.push("/KDPIssueSalesNote");
      }
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err110");
      alertState.value = "error";
      isLoading.value= false;
    });
}

const setConfirmationRoute = () => {
  store.dispatch("setParamKDPSalesNoteList", paramSalesNote);
  router.push("/KDPApprovalRoute");
}


const __returned__ = { isLoading, alertMessage, alertState, i18n, router, isLoadingcheck, paramSalesNote, showModal, goOK, setConfirmationRoute, Navigation, Loading, Alert, SalesNoteLinkNavigation, SalesNoteHeaderNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})